import clsx from 'clsx'
import { HTMLAttributes } from 'react'

import { FeatureBlock, UIFeatureBlock } from '@/shared/ui/feature-block'

import { data } from '../data/data'

import cl from './features-row.module.scss'

type FeaturesRowProps = {
	features?: UIFeatureBlock[]
} & HTMLAttributes<HTMLDivElement>

export const FeaturesRow = (props: FeaturesRowProps) => {
	const { features = data, className, ...rest } = props

	return (
		<div className={clsx(cl.root, className)} {...rest}>
			{features.map((el, i) => (
				<FeatureBlock
					key={i}
					heading={el.heading}
					description={el.description}
					icon={el.icon}
					customIcon={el.customIcon}
				/>
			))}
		</div>
	)
}
